<template>
<div class="container-fluid">
  <student-info></student-info>
  <div class="row">
    <div class="col-12 col-md-12 px-1">
      <current-schedule></current-schedule>
      <current-holds></current-holds>
    </div>
  </div>
  <planner :lookupby="lookupby" :lookupsemester="lookupsemester" :admin="isAdmin" :csc_admin="isCscAdmin"></planner>
  <a name="comments"><semester-messages></semester-messages></a>
</div>
</template>

<style>
  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
    width: 100%;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        display: none;
    }
    .v-expansion-panel--active .v-expansion-panel-header {
        min-height: initial !important;
    }
    .v-expansion-panel-header {
        padding: 10px 10px;
    }
    .search-name-results.list-group {
      min-height: 30vh !important;
      max-height: 30vh !important;
      overflow: auto;
      scrollbar-width: thin;
    }
    .list-group, .v-expansion-panels {
        border: 1px solid #cccccc;
        min-height: 50vh;
        max-height: 50vh;
        overflow: auto;
        scrollbar-width: thin;
    }
    .list-group-item {
        margin-bottom: 3px !important;
        font-size: 90%;
    }
    .list-group-item {
        position: relative;
        display: block;
        padding: 0.4rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, .125);
    }
    .v-expansion-panel-content__wrap {
        padding: 0 5px 16px;
        flex: 1 1 auto;
        max-width: 100%;
        border-top: 1px solid #ccc;
        padding-top: 5px;
    }
    .table {
        margin-bottom: 0rem;
    }
    .table th, .table td {
        padding: 0.4rem .75rem;
    }
</style>

<script>
import StudentInfo from "./StudentPlanner/StudentInfo.vue";
import CurrentSchedule from "./StudentPlanner/CurrentSchedule.vue";
import CurrentHolds from "./StudentPlanner/CurrentHolds.vue";
import Planner from "./StudentPlanner/Planner.vue";
import Messages from "./StudentPlanner/Messages.vue";

export default {
  components: {
    'student-info': StudentInfo,
    'current-schedule': CurrentSchedule,
    'current-holds': CurrentHolds,
    'semester-messages': Messages,
    'Planner': Planner
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    studentId: {     
      type: String,
      required: true,
    },
    isAdmin: {
      type: String,
      required: true,
    },
    isCscAdmin: {
      type: String,
      required: true,
    },
    lookupby: {     
      type: String,
      required: false,
    },
    lookupsemester: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    // vuex store isadvisor boolean value
    this.$store.commit("student/setIsAdvisor", this.isAdmin === 'true');
    // vuex set advisor or currentStudentUin
    if (this.isAdmin === 'true') {
      this.$store.commit("student/setAdvisorUin", this.studentId);
    } else {
      this.$store.commit("student/setCurrentStudentUin", this.studentId);
    }
    
    // this.$nextTick(function () {
    //   Event.$emit("current-student-uin", this.studentId);
    //   Event.$emit("is-admin", this.isAdmin);
    // })
  }
};
</script>
